import React, { useEffect } from 'react';
import ContactInfo from '../Components/ContactInfo/ContactInfo';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <ContactInfo />
  );
};

export default Contact;
